import styled from "styled-components";
import Colors from "../../constants/Colors";
import {deviceMax} from "../../../styles/device";


export const SssContentWrapper = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  background: ${Colors.white};
  border-radius: 6px;
  padding: 23px 40px;

  @media ${deviceMax.tablet} {
    padding: 0;
    background: unset;
  }
`;

export const SssContentContainer = styled.div`
  position: relative;

`;

export const SssContentTitle = styled.h1`
  font-weight: 800;
  font-size: 18px;
  line-height: 55px;
  letter-spacing: 0;
  text-transform: uppercase;
  color: ${Colors.brandColor};
  margin: 0 0 20px 0;

  @media ${deviceMax.tablet} {
    line-height: 30px;
    text-align: center;
    color: ${Colors.blackColor};
    margin: 5px auto 20px;
  }
`;

export const SssContentRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

`;

export const SssContentRowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

`;

export const SssContentRowIcon = styled.div`
  position: relative;

  @media ${deviceMax.tablet} {
    flex: 0 auto;
  }
`;

export const SssContentRowLine = styled.div`
  position: relative;
  width: 100%;
  height: 2px;
  background: ${Colors.blackColor};
  margin: 20px 0;
  
    @media ${deviceMax.tablet} {
        display: none;
    }
`;

export const SssContentRowDetail = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: 55px;

  @media ${deviceMax.tablet} {
    margin-left: 28px;
    flex: 1;
  }
`;

export const SssContentRowDetailTitle = styled.h2`
  position: relative;
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: 0;
  color: ${Colors.blackColor};
  margin: 0 0 20px 0;

  @media ${deviceMax.tablet} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const SssContentRowDetailOption = styled.div`
  position: relative;

  @media ${deviceMax.tablet} {
    display: none;
  }

  > div {
    padding: 0;
    width: 100%;

    > div {
      width: 100%;

      > div {
        width: 100%;

        > fieldset {
          width: 100%;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 10px;

          > div {
            &:not(:first-child) {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
`;

export const SssContentColumnWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  @media ${deviceMax.tablet} {
    display: none;
  }

`;

export const SssContentColumnWrapperMobile = styled.div`
  position: relative;
  display: none;

  @media ${deviceMax.tablet} {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
  }
  
  @media ${deviceMax.mobileM} {
    margin-top: 10px;
  }
`;
